(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lowside-carousel-controls"] && !Shopify.designMode) return;
  try {
    function initLowsideCarousels(root){
    root.querySelectorAll('[data-ls-carousel]').forEach(function(section){
      if(section.dataset.lsReady)return;
      const track=section.querySelector('[data-ls-track]'),nav=section.querySelector('[data-ls-nav]');
      if(!track||!nav)return;
      section.dataset.lsReady='true';
      const prev=nav.querySelector('[data-ls-prev]'),next=nav.querySelector('[data-ls-next]'),status=nav.querySelector('[data-ls-status]');
      let ticking=false;
      function update(){
        const max=track.scrollWidth-track.clientWidth,items=Array.from(track.children),box=track.getBoundingClientRect();
        const visible=items.map((el,i)=>({i:i+1,b:el.getBoundingClientRect()})).filter(item=>item.b.left>=box.left-3&&item.b.left<box.right-8);
        nav.hidden=max<5;
        prev.disabled=track.scrollLeft<5;
        next.disabled=track.scrollLeft>=max-5;
        status.textContent=visible.length?visible[0].i+'–'+visible[visible.length-1].i+' / '+items.length:'';
      }
      function move(dir){
        const first=track.firstElementChild;if(!first)return;
        const step=first.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap||0);
        const count=Math.max(1,Math.round(track.clientWidth/step));
        const current=Math.round(track.scrollLeft/step);
        track.scrollTo({left:(current+dir*count)*step,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
      }
      prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
      track.addEventListener('keydown',function(e){if(e.target!==track)return;if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();move(e.key==='ArrowLeft'?-1:1)}});
      track.addEventListener('scroll',function(){if(ticking)return;ticking=true;requestAnimationFrame(()=>{update();ticking=false})},{passive:true});
      new ResizeObserver(update).observe(track);update();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initLowsideCarousels(document));else initLowsideCarousels(document);
  document.addEventListener('shopify:section:load',()=>initLowsideCarousels(document));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lowside-clarity-toggle"] && !Shopify.designMode) return;
  try {
    (() => {
    const toggle = document.querySelector('[data-lowside-clarity-toggle]');
    if (!toggle) return;

    const label = toggle.querySelector('[data-label]');
    const root = document.documentElement;
    const storageKey = 'lowside_clarity_agent_hidden';
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const getHost = () => document.getElementById('ads-agent-host');
    const getWhatsApp = () => document.querySelector('.ls-whatsapp-float');
    const mobileGap = 12;
    const scanStep = 8;
    let positionFrame = 0;
    let resizeObserver = null;
    let observedWhatsApp = null;
    let lastHost = null;
    let translatedElement = null;
    let translatedOriginal = null;

    const readStoredState = () => {
      try {
        return window.localStorage.getItem(storageKey) === 'true';
      } catch (error) {
        return false;
      }
    };

    const setHidden = (hidden, persist = true) => {
      if (hidden) {
        root.setAttribute('data-lowside-clarity-hidden', '');
      } else {
        root.removeAttribute('data-lowside-clarity-hidden');
      }

      if (persist) {
        try {
          window.localStorage.setItem(storageKey, hidden ? 'true' : 'false');
        } catch (error) {
        }
      }

      toggle.hidden = false;
      toggle.dataset.state = hidden ? 'hidden' : 'visible';
      toggle.setAttribute('aria-pressed', hidden ? 'true' : 'false');
      toggle.setAttribute('aria-label', hidden ? 'Mostrar agente de IA' : 'Ocultar agente de IA');
      if (label) label.textContent = hidden ? 'Mostrar IA' : 'Ocultar IA';

      const host = getHost();
      if (host) {
        const nextValue = hidden ? 'true' : 'false';
        if (host.getAttribute('aria-hidden') !== nextValue) {
          host.setAttribute('aria-hidden', nextValue);
        }
      }
    };

    const clearMobileTranslation = () => {
      if (!translatedElement) return;

      if (translatedOriginal && translatedOriginal.value) {
        translatedElement.style.setProperty('translate', translatedOriginal.value, translatedOriginal.priority);
      } else {
        translatedElement.style.removeProperty('translate');
      }

      translatedElement = null;
      translatedOriginal = null;
    };

    const applyMobileTranslation = (element, deltaX, deltaY) => {
      clearMobileTranslation();
      translatedElement = element;
      translatedOriginal = {
        value: element.style.getPropertyValue('translate'),
        priority: element.style.getPropertyPriority('translate'),
      };
      element.style.setProperty('translate', `${deltaX}px ${deltaY}px`, 'important');
    };

    const isVisible = (element, rect) => {
      if (!element || !rect || rect.width <= 0 || rect.height <= 0) return false;
      const style = window.getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden' && Number.parseFloat(style.opacity || '1') > 0;
    };

    const rectFromShadowTree = (host) => {
      if (!host.shadowRoot) return null;

      const queue = [host.shadowRoot];
      let best = null;
      let bestScore = -Infinity;

      while (queue.length) {
        const currentRoot = queue.shift();
        const elements = currentRoot.querySelectorAll('*');

        for (const element of elements) {
          if (element.shadowRoot) queue.push(element.shadowRoot);

          const rect = element.getBoundingClientRect();
          if (rect.width < 32 || rect.height < 32 || rect.width > 180 || rect.height > 180) continue;
          if (rect.right <= 0 || rect.bottom <= 0 || rect.left >= window.innerWidth || rect.top >= window.innerHeight) continue;
          if (!isVisible(element, rect)) continue;

          const style = window.getComputedStyle(element);
          const role = element.getAttribute('role');
          const tag = element.tagName.toLowerCase();
          let score = rect.left / Math.max(1, window.innerWidth) + rect.top / Math.max(1, window.innerHeight);
          if (tag === 'button' || role === 'button') score += 3;
          if (style.position === 'fixed') score += 2;
          if (style.cursor === 'pointer') score += 1;

          if (score > bestScore) {
            bestScore = score;
            best = { element, rect };
          }
        }
      }

      return best;
    };

    const rectFromHitTest = (host) => {
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      if (viewportWidth <= 0 || viewportHeight <= 0) return null;

      const startX = Math.max(0, viewportWidth - 200);
      const startY = Math.max(0, Math.floor(viewportHeight * 0.2));
      let minX = Infinity;
      let minY = Infinity;
      let maxX = -Infinity;
      let maxY = -Infinity;
      let hits = 0;

      for (let y = startY; y < viewportHeight; y += scanStep) {
        for (let x = startX; x < viewportWidth; x += scanStep) {
          const element = document.elementFromPoint(x, y);
          if (!element) continue;

          const belongsToHost = element === host || host.contains(element);
          if (!belongsToHost) continue;

          hits += 1;
          minX = Math.min(minX, x);
          minY = Math.min(minY, y);
          maxX = Math.max(maxX, x);
          maxY = Math.max(maxY, y);
        }
      }

      if (hits < 3 || !Number.isFinite(minX) || !Number.isFinite(minY)) return null;

      const width = maxX - minX + scanStep;
      height = maxY - minY + scanStep;
      if (width > 190 || height > 190) return null;

      return {
        left: Math.max(0, minX - scanStep / 2),
        top: Math.max(0, minY - scanStep / 2),
        right: Math.min(viewportWidth, maxX + scanStep / 2),
        bottom: Math.min(viewportHeight, maxY + scanStep / 2),
        width,
        height,
      };
    };

    const getLauncherTarget = (host) => {
      const hostRect = host.getBoundingClientRect();
      if (
        isVisible(host, hostRect) &&
        hostRect.width >= 32 &&
        hostRect.height >= 32 &&
        hostRect.width <= 180 &&
        hostRect.height <= 180
      ) {
        return { element: host, rect: hostRect };
      }

      const shadowTarget = rectFromShadowTree(host);
      if (shadowTarget) return shadowTarget;

      const hitRect = rectFromHitTest(host);
      return hitRect ? { element: host, rect: hitRect } : null;
    };

    const positionMobileLauncher = () => {
      positionFrame = 0;

      const host = getHost();
      if (!mobileQuery.matches || !host) {
        clearMobileTranslation();
        return;
      }

      const whatsapp = getWhatsApp();
      if (!whatsapp) {
        clearMobileTranslation();
        return;
      }

      const whatsappRect = whatsapp.getBoundingClientRect();
      if (!isVisible(whatsapp, whatsappRect)) {
        clearMobileTranslation();
        return;
      }

      clearMobileTranslation();

      window.requestAnimationFrame(() => {
        if (!mobileQuery.matches || host !== getHost()) return;

        const launcherTarget = getLauncherTarget(host);
        if (!launcherTarget) return;

        const launcherRect = launcherTarget.rect;
        const desiredRight = Math.max(launcherRect.width + 10, whatsappRect.left - mobileGap);
        const desiredCenterY = whatsappRect.top + whatsappRect.height / 2;
        const currentCenterY = launcherRect.top + launcherRect.height / 2;
        const deltaX = Math.round(desiredRight - launcherRect.right);
        const deltaY = Math.round(desiredCenterY - currentCenterY);

        applyMobileTranslation(launcherTarget.element, deltaX, deltaY);
      });
    };

    const scheduleMobilePosition = () => {
      if (positionFrame) window.cancelAnimationFrame(positionFrame);
      positionFrame = window.requestAnimationFrame(positionMobileLauncher);
    };

    const refreshResizeObserver = () => {
      const whatsapp = getWhatsApp();

      if (typeof window.ResizeObserver === 'function') {
        if (!resizeObserver) resizeObserver = new ResizeObserver(scheduleMobilePosition);
        if (observedWhatsApp && observedWhatsApp !== whatsapp) resizeObserver.unobserve(observedWhatsApp);
        if (whatsapp && observedWhatsApp !== whatsapp) resizeObserver.observe(whatsapp);
      }

      observedWhatsApp = whatsapp;
    };

    const sync = () => {
      const host = getHost();
      if (!host) {
        toggle.hidden = true;
        return;
      }

      if (mobileQuery.matches) {
        root.removeAttribute('data-lowside-clarity-hidden');
        toggle.hidden = true;
        if (host.getAttribute('aria-hidden') !== 'false') host.setAttribute('aria-hidden', 'false');
        scheduleMobilePosition();
        return;
      }

      clearMobileTranslation();
      setHidden(readStoredState(), false);
    };

    if (!mobileQuery.matches && readStoredState()) {
      root.setAttribute('data-lowside-clarity-hidden', '');
    } else {
      root.removeAttribute('data-lowside-clarity-hidden');
    }

    toggle.addEventListener('click', () => {
      if (mobileQuery.matches) return;
      setHidden(!root.hasAttribute('data-lowside-clarity-hidden'));
    });

    const handleMediaChange = () => {
      sync();
      refreshResizeObserver();
      window.setTimeout(scheduleMobilePosition, 250);
    };

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', handleMediaChange);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(handleMediaChange);
    }

    window.addEventListener('resize', scheduleMobilePosition, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleMobilePosition, { passive: true });
    }

    document.addEventListener(
      'click',
      (event) => {
        if (!mobileQuery.matches) return;
        const host = getHost();
        if (!host) return;
        const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
        if (!path.includes(host) && event.target !== host) return;
        window.setTimeout(scheduleMobilePosition, 80);
        window.setTimeout(scheduleMobilePosition, 400);
      },
      true
    );

    const elementObserver = new MutationObserver(() => {
      const nextHost = getHost();
      const nextWhatsApp = getWhatsApp();
      const hostChanged = nextHost !== lastHost;
      const whatsappChanged = nextWhatsApp !== observedWhatsApp;
      if (!hostChanged && !whatsappChanged) return;

      if (hostChanged && lastHost) clearMobileTranslation();
      lastHost = nextHost;
      sync();
      refreshResizeObserver();
      window.setTimeout(scheduleMobilePosition, 250);
    });

    elementObserver.observe(document.body, { childList: true, subtree: true });
    lastHost = getHost();
    sync();
    refreshResizeObserver();
    window.setTimeout(scheduleMobilePosition, 250);
    window.setTimeout(scheduleMobilePosition, 900);
    window.setTimeout(scheduleMobilePosition, 1800);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lowside-us-size-switch"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lowside-us-size-switch')) {
    customElements.define('lowside-us-size-switch', class extends HTMLElement {
      connectedCallback() {
        this.start = () => this.initialize();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.start, { once: true });
        } else {
          this.initialize();
        }
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.start);
        this.option?.removeEventListener('click', this.onOptionClick);
        this.observer?.disconnect();
        this.ready = false;
      }
      initialize() {
        if (this.ready || !this.isConnected) return;
        this.option = this.closest('.ls-option');
        if (!this.option) return;
        const position = this.dataset.optionPosition;
        this.sizeButtons = Array.from(this.option.querySelectorAll('.ls-size-btn[data-option-position]'))
          .filter(button => button.dataset.optionPosition === position);
        this.offset = Number(this.dataset.offset);
        this.sizes = this.sizeButtons.map(button => {
          const match = /^US\s+([MW])\s+(\d+(?:\.5)?)$/i.exec(button.dataset.optionValue.trim());
          if (!match) return null;
          const source = match[1].toUpperCase();
          const number = Number(match[2]);
          const men = source === 'M' ? number : number - this.offset;
          const women = men + this.offset;
          return { button, source, men, women };
        });
        if (!this.sizes.length || this.sizes.some(size => !size || size.men < 3.5 || size.women > 23.5)) return;
        if (new Set(this.sizes.map(size => size.source)).size !== 1) return;
        if (this.offset === 1 && this.sizes.some(size => size.men < 4 || size.men > 14.5)) return;
        this.system = this.system || this.sizes[0].source;
        this.ready = true;
        this.onOptionClick = event => {
          const control = event.target.closest('[data-us-system]');
          if (control && this.contains(control)) {
            this.system = control.dataset.usSystem;
            this.renderSizes();
          } else if (event.target.closest('.ls-size-btn')) {
            this.renderEquivalent();
          }
        };
        this.option.addEventListener('click', this.onOptionClick);
        this.observer = new MutationObserver(() => this.renderEquivalent());
        this.sizes.forEach(size => this.observer.observe(size.button, { attributes: true, attributeFilter: ['class'] }));
        this.renderSizes();
        this.hidden = false;
      }
      renderSizes() {
        this.querySelectorAll('[data-us-system]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.usSystem === this.system));
        });
        this.sizes.forEach(size => {
          const label = 'US ' + this.system + ' ' + (this.system === 'M' ? size.men : size.women);
          size.button.textContent = label;
          size.button.setAttribute('aria-label', label);
        });
        this.renderEquivalent();
      }
      renderEquivalent() {
        const active = this.sizes.find(size => size.button.classList.contains('active'));
        this.querySelector('[data-us-equivalent]').textContent = active ? 'US M ' + active.men + ' = US W ' + active.women : '';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
